import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Animation, TweenLite, TweenMax} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoParsedGameData} from "../server/data/CreepyCarnivalTwoParsedGameData";
import {CCTwoInitialWPEvents} from "../winpresentation/initial/CreepyCarnivalTwoInitialWPController";


export class CreepyCarnivalBulbsEvent {

    static readonly SHOW_WIN_ATTENTION_BULBS:string = "CCT_SHOW_WIN_ATTENTION_BULBS";
    static readonly SHOW_FREE_SPIN_BULBS:string = "CCT_SHOW_FREESPIN_BULBS";
    static readonly SHOW_ALL_FREE_SPIN_BULBS:string = "CCT_SHOW_ALL_FREESPIN_BULBS";
    static readonly SHOW_STAR_SPIN_BULBS:string = "CCT_SHOW_STAR_SPIN_BULBS";
    static readonly HIDE_STAR_SPIN_BULBS:string = "CCT_HIDE_STAR_SPIN_BULBS";
    static readonly HIDE_FREE_SPIN_BULBS:string = "CCT_HIDE_FREESPIN_BULBS";
    static readonly HIDE_ALL_FREE_SPIN_BULBS:string = "CCT_HIDE_ALL_FREESPIN_BULBS";
    static readonly HIDE_WIN_ATTENTION_BULBS:string = "CCT_HIDE_WIN_ATTENTION_BULBS";
    static readonly BLINKING_EFFECT_BULBS:string = "CCT_BLINKING_EFFECT_BULBS";
    static readonly KILL_BLINKING_EFFECT_BULBS:string = "CCT_KILL_BLINKING_EFFECT_BULBS";
    static readonly HIDE_YELLOW_BULBS_FOR_BIG_WIN:string = "CCT_HIDE_YELLOW_BULBS_FOR_BIG_WIN";
    static readonly SHOW_YELLOW_BULBS_FOR_BIG_WIN:string = "CCT_SHOW_YELLOW_BULBS_FOR_BIG_WIN";
}

export class CCTwoBulb extends BaseView {
    private _layer:PIXI.Container;
    private _bulbFrame:PIXI.Sprite;
    private _container_left:PIXI.Container = new PIXI.Container();
    private _container_right:PIXI.Container = new PIXI.Container();
    private _red_container:PIXI.Container = new PIXI.Container();
    private _green_container:PIXI.Container = new PIXI.Container();
    private _red_container_right:PIXI.Container = new PIXI.Container();
    private _noOfBulbs:number;
    private _isBigWinOver:boolean;
    private _yellow_container:PIXI.Container = new PIXI.Container();
    private _bulbBlinkingAnim:Animation[] = [];

    constructor() {
        super();

        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.BULBS.name);
        this._noOfBulbs = CreepyCarnivalTwoGameConfig.instance.BULBS_NUMBER;
        this._red_container.name = "red_container";
        this._yellow_container.name = "yellow_container";
        this._green_container.name = "green_container";

    }

    // Hardcoded default even number betLines. positionIndex starts from 0.
    public setPosition(positionIndex:number):number[] {
        const horizontalPadding = 246;
        const verticalPadding = 120;
        const stageWidth:number = CreepyCarnivalTwoGameConfig.instance.GAME_WIDTH;
        const stageHeight:number = CreepyCarnivalTwoGameConfig.instance.GAME_HEIGHT;
        const numLineInOneSide:number = this._noOfBulbs / 2;
        const numberLeftPositionX:number = horizontalPadding;
        const numberRightPositionX:number = stageWidth - horizontalPadding - 20;
        const numberVerticalSpace:number = 43;
        const side:number = Math.floor(positionIndex / numLineInOneSide);
        const x:number = side === 0 ? numberLeftPositionX : numberRightPositionX;
        const y:number = Math.round(positionIndex % numLineInOneSide * numberVerticalSpace + verticalPadding);
        return [x, y, side];
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_FREE_SPIN_BULBS, (event:GameEvent) => this.highLightRedBulbs(event.params[0]));
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_STAR_SPIN_BULBS, (event:GameEvent) => this.showGreenBulbs());
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.DISPLAY_STAR_SPIN_BULBS_AT_ONCE, (event:GameEvent) => this.starBulbsAtOnce());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_STAR_SPIN_BULBS, (event:GameEvent) => this.hideGreenBulbs());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_ALL_FREE_SPIN_BULBS, (event:GameEvent) => this.showRedBulbs());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_ALL_FREE_SPIN_BULBS, (event:GameEvent) => this.hideRedBulbs());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_WIN_ATTENTION_BULBS, (event:GameEvent) => this.showYellowBulbs());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_WIN_ATTENTION_BULBS, (event:GameEvent) => this.hideYellowBulbs());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_YELLOW_BULBS_FOR_BIG_WIN, (event:GameEvent) => this.bigWinStartCall());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_YELLOW_BULBS_FOR_BIG_WIN, (event:GameEvent) => this.bigWinEndCall());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.BLINKING_EFFECT_BULBS, (event:GameEvent) => this.playBlinkingEffect());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.KILL_BLINKING_EFFECT_BULBS, (event:GameEvent) => this.killBlinkingAnimation());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.hideRedBulbs());

    }

    protected initAnimations():void {
        for(let i = 0; i < this._noOfBulbs; i++) {
            const bulbFrame = new PIXI.Sprite(GameResources.getTextures("assets/lightbulb")[0]);
            const red_bulbFrame = new PIXI.Sprite(GameResources.getTextures("assets/lightbulb_red")[0]);
            const green_bulbFrame = new PIXI.Sprite(GameResources.getTextures("assets/lightbulb_green")[0]);
            const yellow_bulbFrame = new PIXI.Sprite(GameResources.getTextures("assets/lightbulb_yellow")[0]);
            bulbFrame.anchor.set(0.5, 0.5);
            bulbFrame.scale.set(0.8, 0.8);
            red_bulbFrame.anchor.set(0.5, 0.5);
            red_bulbFrame.alpha = 0;
            red_bulbFrame.scale.set(0.8, 0.8);
            yellow_bulbFrame.anchor.set(0.5, 0.5);
            yellow_bulbFrame.alpha = 0;
            yellow_bulbFrame.scale.set(0.8, 0.8);
            green_bulbFrame.anchor.set(0.5, 0.5);
            green_bulbFrame.alpha = 0;
            green_bulbFrame.scale.set(0.8, 0.8);
            const position = this.setPosition(i);
            bulbFrame.position.set(position[0] + 11, position[1]);
            red_bulbFrame.position.set(position[0] + 11, position[1]);
            green_bulbFrame.position.set(position[0] + 11, position[1]);
            yellow_bulbFrame.position.set(position[0] + 11, position[1]);
            if(position[2] === 0) {
                this._container_left.addChild(bulbFrame);
                this._red_container.addChild(red_bulbFrame);
                this._green_container.addChild(green_bulbFrame);
                this._yellow_container.addChild(yellow_bulbFrame);
            } else {
                this._container_right.addChild(bulbFrame);
                this._red_container.addChild(red_bulbFrame);
                this._green_container.addChild(green_bulbFrame);
                this._yellow_container.addChild(yellow_bulbFrame);
            }
        }
        this._layer.addChild(this._container_left);
        this._layer.addChild(this._container_right);
        this._layer.addChild(this._red_container);
        this._layer.addChild(this._green_container);
        this._layer.addChild(this._yellow_container);
    }

    private showGreenBulbs():void {
        for(let i = 0; i < 20; i++) {
            setTimeout(() => {
                this._green_container.getChildAt(i).alpha = 1;
            }, i * 100)
        }
    }

    private starBulbsAtOnce():void {
        for(let i = 0; i < 20; i++) {
            this._green_container.getChildAt(i).alpha = 1;
        }
    }

    private hideGreenBulbs():void {
        for(let i = 0; i < 20; i++) {
            setTimeout(() => {
                this._green_container.getChildAt(i).alpha = 0;
            }, i * 25)
        }
    }

    private showYellowBulbs():void {
        for(let i = 0; i < 20; i++) {
            this._yellow_container.getChildAt(i).alpha = 1;
        }
    }

    private hideYellowBulbs():void {
        for(let i = 0; i < this._yellow_container.children.length; i++) {
            this._yellow_container.getChildAt(i).alpha = 0;
        }
    }

    private showYellowBulbsForBigWin():void {
        if(!this._isBigWinOver) {
            for(let i = 0; i < 20; i++) {
                this._yellow_container.getChildAt(i).alpha = 1;
            }
            setTimeout(() => {
                this.hideYellowBulbsForBigWin();
            }, 500);
        }
    }

    private hideYellowBulbsForBigWin():void {
        if(!this._isBigWinOver) {
            for(let i = 0; i < this._yellow_container.children.length; i++) {
                this._yellow_container.getChildAt(i).alpha = 0;
            }
            setTimeout(() => {
                this.showYellowBulbsForBigWin();
            }, 500);
        }
    }

    private showRedBulbs():void {
        for(let i = 0; i < this._yellow_container.children.length; i++) {

            this._red_container.getChildAt(i).alpha = 1;

        }
    }

    private bigWinEndCall():void {
        this.hideYellowBulbsForBigWin();
        this._isBigWinOver = true;
    }

    private bigWinStartCall():void {
        this._isBigWinOver = false;
        this.showYellowBulbsForBigWin();
    }

    private playBlinkingEffect() {
        this._bulbBlinkingAnim = [];
        for(let i = 0; i < this._red_container.children.length; i++) {
            this._red_container.getChildAt(i).alpha = 1;
            this.creatingBlinkingEffect(<PIXI.Sprite>this._red_container.getChildAt(i), i);
        }
    }

    private creatingBlinkingEffect(redBulb:PIXI.Sprite, index:number) {
        this._bulbBlinkingAnim[index] = TweenMax.fromTo(redBulb, 0.3, {
            alpha : 1
        }, {
            alpha : 0.1,
            yoyo : true,
            repeat : -1,
            onComplete : () => {
                redBulb.alpha = 0;
            }
        });


        this._bulbBlinkingAnim[index].play(0);
    }

    private killBlinkingAnimation() {
        for(let i = 0; i < this._bulbBlinkingAnim!.length; i++) {
            this._bulbBlinkingAnim[i].kill();
            this._red_container.getChildAt(i).alpha = 0;
        }
    }

    private hideRedBulbs():void {
        for(let i = 0; i < this._red_container.children.length; i++) {
            this._red_container.getChildAt(i).alpha = 0;
        }
    }

    private highLightRedBulbs(data:any) {
        let bulbIndex = data.x;
        let timeline = data.z;
        timeline.add(() => {
            TweenLite.fromTo(this._red_container.getChildAt(bulbIndex), 0.3, {alpha : 0}, {alpha : 1})
        });
    }


    private onServerDataParsed(data:CreepyCarnivalTwoParsedGameData):void {
        if(data.specialSymbolsLength) {

        }
        if(data.multiplier === 5) {

        }
        if(data.specialSymbolsLengthAfter > 0) {

        }
    }
}